import React from 'react';
import Jumbotron from 'react-bootstrap/Jumbotron';

function Home() {
    return (
        <div>
            <Jumbotron style={{ margin: 0, borderRadius: 0 }}>
                <h1>Hey, it's Arnav!</h1>
                <p>
                    Hi! Welcome to my website!
                </p>
            </Jumbotron>
            <Jumbotron style={{ margin: 0, borderRadius: 0, backgroundColor: '#ADD8E6' }}>
                <h1>About Me</h1>
                <ul>
                    <li>I'm a rising 9th grader from Houston, Texas.</li>
                    <li>I love Math and Coding! I also enjoy Tennis, Basketball, Quiz Bowl, and Robotics.</li>
                    <li>Monkeys, dogs, and bears are the best animals.</li>
                    <li>Check out my <a href="/publications">publications</a>!</li>
                </ul>
            </Jumbotron>
        </div>
        
    );
}

export default Home;